// src/service/PlantService.ts
import { Plant } from "@models/plant";
import axiosClient from "./axiosClient";
import { IPlantDTO } from "@interfaces/IPlantDTO";
import { IPlantConfigurationDTO } from "@interfaces/IPlantConfigurationDTO";
import {
  IEngagementStatusesDTO,
  IEngagementStatusDTO,
} from "@interfaces/IEngagementStatusesDTO";
export interface PlantOption {
  id: number;
  value: string;
}

export function fetchPlants(): Promise<PlantOption[]> {
  return axiosClient.get<Plant[]>("/plant_api/plants").then((res) =>
    // turn each Plant into the Combobox-friendly { id, value } shape
    res.data.map(
      (p): PlantOption => ({
        id: p.id,
        value: p.name,
      })
    )
  );
}
export function savePlant(data: Partial<IPlantDTO>) {
  return axiosClient.post<{ status: string; message: string }>(
    "/plant_api/update",
    data
  );
}
export function createPlant(data: Partial<IPlantDTO>) {
  return axiosClient.post<{ status: string; message: string }>(
    "/plant_api/create",
    data
  );
}

export function savePlantConfiguration(data: Partial<IPlantConfigurationDTO>) {
  return axiosClient.post<{ status: string; message: string }>(
    `/plantconfiguration_api/create/${data.plant_id}`,
    data
  );
}
export function fetchEngagementStatus(): Promise<IEngagementStatusesDTO[]> {
  return axiosClient
    .get<IEngagementStatusesDTO[]>("/plant_api/engagement/statuses/list")
    .then((res) => res.data);
}

export function fetchEngagementStatusbyID(data: {
  plant_id: number;
}): Promise<IEngagementStatusDTO> {
  return axiosClient
    .post("/plant_api/engagement/status", data)
    .then((res) => res.data);
}
